// src/modules/components/reports/calls/SummaryCards.js
import React from "react";
import { Grid } from "@mui/material";
import SummaryCard from "./SummaryCard";
import {
  Phone as PhoneIcon,
  CheckCircle as AnsweredIcon,
  Schedule as DurationIcon,
  People as AgentIcon,
} from "@mui/icons-material";

const SummaryCards = ({ summary }) => {
  const formatTime = (seconds) => {
    if (!seconds) return "0s";
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  };

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard
          title="Total Calls"
          value={summary?.totalCalls || 0}
          icon={PhoneIcon}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard
          title="Answered Calls"
          value={summary?.answeredCalls || 0}
          secondaryValue={`${summary?.answerRate || 0}% answer rate`}
          icon={AnsweredIcon}
          color="success"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard
          title="Avg Duration"
          value={formatTime(summary?.avgDuration || 0)}
          secondaryValue={`${summary?.missedCalls || 0} missed calls`}
          icon={DurationIcon}
          color="info"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SummaryCard
          title="Unique Callers"
          value={summary?.uniqueCallers || 0}
          secondaryValue={`${formatTime(summary?.totalDuration || 0)} total talk time`}
          icon={AgentIcon}
          color="warning"
        />
      </Grid>
    </Grid>
  );
};

export default SummaryCards;